$tab-navigation-tab-height: 48px;
$tab-navigation-tab-gap: 12px;
$tab-navigation-tab-padding-x: 16px;
$tab-navigation-tab-padding-y: 12px;
$tab-navigation-tab-border-width-default: 1px;
$tab-navigation-tab-border-width-focused: 2px;
$tab-navigation-tab-border-width-selected: 8px;
$tab-navigation-content-padding-x: 16px;
$tab-navigation-content-padding-y: 32px;
$tab-navigation-sticky-offset: var(--sticky-offset, 0);

:host {
  display: inline-flex;
}

.dc-ui-anchor-bar-item {
  position: relative;
  padding: $tab-navigation-tab-padding-y $tab-navigation-tab-padding-x;
  border: 0;
  outline: 0;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: bold;
  user-select: none;
  white-space: nowrap;
  color: $color-grey-06;
  background-color: transparent;
  cursor: pointer;

  &--selected {
    box-shadow: inset 0 calc($tab-navigation-tab-border-width-selected * -1) $color-turquoise-01;
    background-color: $color-grey-01;

    &:hover {
      background-color: $color-grey-02;
    }

    &:focus-visible {
      box-shadow:
        inset 0 0 0 $tab-navigation-tab-border-width-default $color-grey-01,
        inset 0
          calc(
            ($tab-navigation-tab-border-width-selected - $tab-navigation-tab-border-width-focused) *
              -1
          )
          $color-turquoise-01;

      &:hover {
        box-shadow:
          inset 0 0 0 $tab-navigation-tab-border-width-default $color-grey-02,
          inset 0
            calc(
              ($tab-navigation-tab-border-width-selected - $tab-navigation-tab-border-width-focused) *
                -1
            )
            $color-turquoise-01;
      }
    }
  }

  &--selected,
  &:hover {
    color: $color-dark-blue-02;
    font-weight: 900;
  }

  &:focus-visible {
    padding: calc($tab-navigation-tab-padding-y - $tab-navigation-tab-border-width-focused)
      calc($tab-navigation-tab-padding-x - $tab-navigation-tab-border-width-focused);
    border: $tab-navigation-tab-border-width-focused solid $color-turquoise-03;
  }

  &--disabled {
    color: $color-grey-03;
    cursor: not-allowed;

    & > * {
      pointer-events: none;
    }
  }

  .hidden-text {
    visibility: hidden;
    font-weight: 900;
    height: 0;
    overflow: hidden;
  }
}
